import React from "react";
import styles from "./TaskCardList.module.css";

const TaskCardSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div
          className={styles.skeleton}
          style={{ width: "7.5rem", height: "1rem" }}
        />
        <div
          className={styles.skeleton}
          style={{ width: "3.75rem", height: "0.875rem" }}
        />
      </div>
      <div className={styles.cardBody}>
        <div
          className={styles.cardRow}
          style={{ display: "flex", flexDirection: "column", gap: "0.25rem", alignItems: "flex-start" }}
        >
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <span className={styles.cardLabel}>Payment:</span>
            <div
              className={styles.skeleton}
              style={{ width: "6.25rem", height: "0.875rem" }}
            />
          </div>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <span className={styles.cardLabel}>Expires:</span>
            <div
              className={styles.skeleton}
              style={{ width: "5rem", height: "0.875rem" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskCardSkeleton;
